/**
 * Strips <user interrupted> markers from content blocks.
 * Returns null if the content only contains the interrupt marker.
 * 
 * @param content - The content to process
 * @returns The cleaned content or null if it should not be displayed
 */
export function stripInterruptMarkers(content: string): string | null {
  // Check if content is only the interrupt marker (possibly with whitespace)
  if (content.trim() === "<user interrupted>") {
    return null;
  }
  
  // Remove the interrupt marker from the end of content
  // Handle cases with or without preceding newlines
  const cleaned = content
    .replace(/\n*<user interrupted>$/, "")
    .replace(/<user interrupted>$/, "");
  
  // If removing the marker leaves us with empty content, return null
  if (cleaned.trim() === "") {
    return null;
  }
  
  return cleaned;
}